import { Check,Server } from "lucide-react";

export const InstanceNameInput = ({
  register,
  validationError,
  instanceNameValue,
  focusedField,
  setFocusedField,
}) => {
  const isFocused = focusedField === "instanceName";

  return (
    <div>
      <label
        htmlFor="instanceName"
        className="block text-sm font-medium text-gray-700 mb-1"
      >
        Instance Name
      </label>
      <div
        className={`relative rounded-md ${
          isFocused ? "ring-2 ring-indigo-500" : ""
        }`}
      >
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <Server
            className={`h-5 w-5 ${
              isFocused ? "text-indigo-500" : "text-gray-400"
            }`}
          />
        </div>
        <input
          {...register("instanceName")}
          id="instanceName"
          name="instanceName"
          type="text"
          onFocus={() => setFocusedField("instanceName")}
          onBlur={() => setFocusedField(null)}
          aria-invalid={!!validationError}
          aria-describedby={validationError ? "instanceName-error" : undefined}
          className={`block w-full pl-10 pr-3 py-3 border ${
            validationError ? "border-red-300" : "border-gray-300"
          } rounded-lg shadow-sm`}
          placeholder="Instance Name"
        />
        {instanceNameValue && !validationError && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <Check className="h-5 w-5 text-green-500" />
          </div>
        )}
      </div>
      {validationError && (
        <p className="mt-2 text-sm text-red-600" id="instanceName-error">
          {validationError.message}
        </p>
      )}
    </div>
  );
};
